import { NgModule } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ResizeModule} from './commons/directives/resize/resize.module';
import {AdvancedTreeFilterModule} from './commons/pipes/advanced-tree-filter/advanced-tree-filter.module';
import {ColumnFilterModule} from './commons/pipes/column-filter/column-filter.module';
import {DomSanitizerModule} from './commons/pipes/dom-sanitizer/dom-sanitizer.module';
import {GlobalSearchFilterModule} from './commons/pipes/global-search-filter/global-search-filter.module';
import {ListSearchPipeModule} from './commons/pipes/list-search/list-search.pipe.module';
import {OrderByPipeModule} from './commons/pipes/order-by-pipe/order-by-pipe.module';
import {SearchFilterPipeModule} from './commons/pipes/search-filter/search-filter.pipe.module';
import {ShortstringModule} from './commons/pipes/string-short/string-short.module';
import {TreeFilterPipeModule} from './commons/pipes/tree-filter-pipe/tree-filter-pipe.module';
import {UrlSanitizerModule} from './commons/pipes/url-sanitizer/url-sanitizer.module';
import {LuciAccordionModule} from './luci-accordion/luci-accrodian.module';
import {LuciBadgesModule} from './luci-badges/luci-badges.module';
import {LuciButtonModule} from './luci-button/luci-button.module';
import {LuciCheckboxModule} from './luci-checkbox/luci-checkbox.module';
import {LuciChipsModule} from './luci-chips/luci-chips.module';
import {LuciDialogModule} from './luci-dialog/luci-dialog.module';
import {LuciDropdownModule} from './luci-dropdown/luci-dropdown.module';
import {LuciGlobalSearchModule} from './luci-global-search/luci-global-search.module';
import {LuciInputModule} from './luci-input/luci-input.module';
import {LuciLoaderModule} from './luci-loader/luci-loader.module';
import {LuciMastheadsModule} from './luci-mastheads/luci-mastheads.module';
import {LuciMenuModule} from './luci-menu/luci-menu.module';
import {LuciPaginationModule} from './luci-pagination/luci-pagination.module';
import {LuciPopoverModule} from './luci-popover/luci-popover.module';
import {LuciRadioModule} from './luci-radio/luci-radio.module';
import {LuciSearchModule} from './luci-search/luci-search.module';
import {LuciSwitchModule} from './luci-switch/luci-switch.module';
import {LuciTableModule} from './luci-table/luci-table.module';
import {LuciTabsModule} from './luci-tabs/luci-tabs.module';
import {LuciTooltipsModule} from './luci-tooltips/luci-tooltips.module';
import {LuciTreeModule} from './luci-tree/luci-tree.module';
import {LuciTreeTableModule} from './luci-tree-table/luci-tree-table.module';
import {LuciToolbarModule} from './luci-toolbar/luci-toolbar.module';
import {LuciAccordionPanelModule} from './luci-accordion/luci-accordion-panel/luci-accordion-panel.module';
import {LuciPersonalizationTableColumnsModule} from './luci-personalization-table-columns/luci-personalization-table-columns.module';
import {LuciTableMultiColumnSortingModule} from './luci-table-multi-column-sorting/luci-table-multi-column-sorting.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ResizeModule,
    AdvancedTreeFilterModule,
    ColumnFilterModule,
    DomSanitizerModule,
    GlobalSearchFilterModule,
    ListSearchPipeModule,
    OrderByPipeModule,
    SearchFilterPipeModule,
    ShortstringModule,
    TreeFilterPipeModule,
    UrlSanitizerModule,
    LuciAccordionModule,
    LuciAccordionPanelModule,
    LuciBadgesModule,
    LuciButtonModule,
    LuciCheckboxModule,
    LuciChipsModule,
    LuciDialogModule,
    LuciDropdownModule,
    LuciGlobalSearchModule,
    LuciInputModule,
    LuciLoaderModule,
    LuciMastheadsModule,
    LuciMenuModule,
    LuciPaginationModule,
    LuciPopoverModule,
    LuciRadioModule,
    LuciSearchModule,
    LuciSwitchModule,
    LuciTableModule,
    LuciTabsModule,
    LuciTooltipsModule,
    LuciTreeModule,
    LuciTreeTableModule,
    LuciToolbarModule,
    LuciPersonalizationTableColumnsModule,
    LuciTableMultiColumnSortingModule
  ],
  exports: [
    ResizeModule,
    AdvancedTreeFilterModule,
    ColumnFilterModule,
    DomSanitizerModule,
    GlobalSearchFilterModule,
    ListSearchPipeModule,
    OrderByPipeModule,
    SearchFilterPipeModule,
    ShortstringModule,
    TreeFilterPipeModule,
    UrlSanitizerModule,
    LuciAccordionModule,
    LuciAccordionPanelModule,
    LuciBadgesModule,
    LuciButtonModule,
    LuciCheckboxModule,
    LuciChipsModule,
    LuciDialogModule,
    LuciDropdownModule,
    LuciGlobalSearchModule,
    LuciInputModule,
    LuciLoaderModule,
    LuciMastheadsModule,
    LuciMenuModule,
    LuciPaginationModule,
    LuciPopoverModule,
    LuciRadioModule,
    LuciSearchModule,
    LuciSwitchModule,
    LuciTableModule,
    LuciTabsModule,
    LuciTooltipsModule,
    LuciTreeModule,
    LuciTreeTableModule,
    LuciToolbarModule,
    LuciPersonalizationTableColumnsModule,
    LuciTableMultiColumnSortingModule
  ]
})
export class NgLuciModule { }
